import React, { useEffect, useState } from 'react';
import { setTimeout } from 'timers';

function useDebounce<T>(value: T, delay?: number): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value)
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500)
        return () => {
            clearTimeout(timer)
        }
    }, [value, delay])
    return debouncedValue
}


const InputConfigure: React.FC<{ title: string, text: string, onUpdate(text: string): void }> = (props) => {
    const [value, setValue] = useState<string>('');
    const [isEditable, setEditable] = useState<boolean>(false);
    const debouncedValue = useDebounce<string>(value, 500);

    useEffect(() => {        
        setEditable((!!value && value !== props.text));
    }, [debouncedValue]);

    return (
        <div className="field">
            <label className="label">{props.title}</label>
            <div className="options123">
            <div className="control">
                <input className="input" type="text" defaultValue={props.text} onChange={(e) => {
                    setValue(e.target.value);
                }} />
            </div>
            {
                (isEditable) && (
                    <button className="button is-primary" onClick={() => {
                        props.onUpdate(value);
                    }}>
                        <span className="icon">
                            <i className="fas fa-edit"></i>
                        </span>
                        <span>Editar</span>
                    </button>
                )
            }
            </div>
        </div>
    );
}

export default InputConfigure;